import $axiosProtected from '../../common/utils/axiosUtils';

type GetPatientReportsPayload = {
    search?: string;
    conditionNames?: string[];
    startDate?: string; // YYYY-MM-DD
    endDate?: string; // YYYY-MM-DD
    limit: number;
    page: number;
};

export const getPatientConditionTestReports = async (
    payload: GetPatientReportsPayload
) => {
    const params = new URLSearchParams();
    if (payload.search) params.append('search', String(payload.search));
    if (Array.isArray(payload.conditionNames)) {
        for (const name of payload.conditionNames) {
            if (name) params.append('conditionName', String(name));
        }
    }
    if (payload.startDate)
        params.append('startDate', String(payload.startDate));
    if (payload.endDate) params.append('endDate', String(payload.endDate));
    params.append('limit', String(payload.limit));
    params.append('page', String(payload.page));

    return await $axiosProtected().get(
        `/patient/v2/condition-details/test/report?${params.toString()}`
    );
};

export default getPatientConditionTestReports;
